module.exports = __webpack_public_path__ + "static/desktop/img/step-calendar.188c27ef.png";